import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageSEO } from './SEO';

export const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-white">
      <PageSEO 
        title="Mentions légales & CGV" 
        description="Mentions légales et conditions générales de service de Nailed by Chloé - Prothésiste ongulaire à domicile à La Réunion"
      />
      
      {/* Header simple */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-600 hover:text-rose-600 transition-colors"
          >
            <ArrowLeft size={20} />
            <span className="font-medium">Retour au site</span>
          </Link>
        </div>
      </header>

      {/* Contenu */}
      <main className="container mx-auto px-4 py-8 md:py-12">
        <article className="max-w-3xl mx-auto prose prose-gray prose-lg">
          
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
            Mentions légales & Conditions générales de service
          </h1>
          
          <p className="text-rose-600 font-semibold text-lg mb-2">
            Nailed by Chloé - Prothésiste ongulaire à domicile
          </p>
          
          <p className="text-gray-500 text-sm mb-8">
            Dernière mise à jour : 7 janvier 2026
          </p>

          {/* Section 1 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">1. Identification</h2>
            <div className="bg-gray-50 rounded-xl p-4 md:p-6 space-y-2">
              <p><strong>Prestataire :</strong> Nailed by Chloé</p>
              <p><strong>Localisation :</strong> Ravine des Cabris, La Réunion</p>
              <p><strong>Téléphone :</strong> <a href="tel:+33640486009" className="text-rose-600 hover:underline">+33 6 40 48 60 09</a></p>
              <p><strong>Email/Contact :</strong> Via formulaire de contact sur le site</p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">2. Services proposés</h2>
            <p className="mb-3">Nous proposons les services suivants à domicile :</p>
            <ul className="list-disc list-inside space-y-1 mb-4 text-gray-600">
              <li>Pose de vernis Semi permanent</li>
              <li>Gainage d'ongles naturels</li>
              <li>Extensions d'ongles (Gel-X, capsules, Popit)</li>
              <li>Remplissage et entretien</li>
              <li>Services pour mains et pieds</li>
            </ul>
            <div className="bg-rose-50 rounded-xl p-4 md:p-6 space-y-2 text-sm">
              <p><strong>Durée des prestations :</strong> De 45 minutes à 3h30 selon le service choisi</p>
              <p><strong>Zones desservies :</strong> Ravine des Cabris, Saint-Pierre, Le Tampon (déplacement compris dans le prix)</p>
              <p><strong>Zones éloignées :</strong> Saint-Louis, Saint-Leu, Les Avirons, Étang-Salé, Petite-Île, Saint-Joseph</p>
              <p><strong>Supplément zone éloignée :</strong> +10€ (dégressif selon la prestation)</p>
            </div>
          </section>

          {/* Section 3 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">3. Conditions de réservation</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Les réservations se font via WhatsApp ou formulaire de contact</li>
              <li>Une confirmation du rendez-vous sera envoyée</li>
              <li>Le service est effectué à votre domicile (zone convenue)</li>
            </ul>
          </section>

          {/* Section 4 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">4. Conditions d'annulation et de modification</h2>
            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 bg-green-50 rounded-lg">
                <span className="text-green-600 font-bold">✓</span>
                <div>
                  <strong className="text-green-800">Annulation avec délai</strong>
                  <p className="text-green-700 text-sm">Annulation gratuite jusqu'à 24h avant le rendez-vous</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 bg-amber-50 rounded-lg">
                <span className="text-amber-600 font-bold">!</span>
                <div>
                  <strong className="text-amber-800">Annulation de dernière minute</strong>
                  <p className="text-amber-700 text-sm">Moins de 24h = frais d'annulation de 50% du montant de la prestation</p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 bg-red-50 rounded-lg">
                <span className="text-red-600 font-bold">✗</span>
                <div>
                  <strong className="text-red-800">Non-présentation</strong>
                  <p className="text-red-700 text-sm">Sans annulation préalable = montant intégral facturé</p>
                </div>
              </div>
            </div>
            <p className="mt-4 text-gray-600 text-sm">
              Les modifications de date/horaire doivent être demandées au maximum 24h avant le rendez-vous.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">5. Hygiène & sécurité</h2>
            <p className="mb-3">Tous les instruments et matériaux utilisés respectent les normes d'hygiène et de sécurité :</p>
            <ul className="list-disc list-inside space-y-1 mb-4 text-gray-600">
              <li>Matériel stérile et désinfecté entre chaque client</li>
              <li>Respect des protocoles de sécurité sanitaire</li>
              <li>Utilisation de produits professionnels de qualité</li>
            </ul>
            <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg">
              <p className="font-semibold text-amber-800 mb-2">⚠️ Contre-indications</p>
              <p className="text-amber-700 text-sm mb-2">Le service ne peut pas être effectué en cas de :</p>
              <ul className="list-disc list-inside space-y-1 text-amber-700 text-sm">
                <li>Infection ou maladie contagieuse</li>
                <li>Plaies ouvertes ou blessures</li>
                <li>Allergie connue aux produits utilisés</li>
                <li>Traitement médical incompatible</li>
              </ul>
            </div>
          </section>

          {/* Section 6 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">6. Responsabilité & limitation</h2>
            <p className="mb-3">Nailed by Chloé ne peut être tenue responsable de :</p>
            <ul className="list-disc list-inside space-y-1 mb-4 text-gray-600">
              <li>Réactions allergiques (déclaration obligatoire avant service)</li>
              <li>Problèmes dermatologiques préexistants</li>
              <li>Dommages non liés à la prestation effectuée</li>
              <li>Cas de force majeure (épidémie, tempête, etc.)</li>
            </ul>
            <p className="text-gray-600 text-sm italic">
              Le client accepte que les allergies éventuelles lui incombent. En cas de doute, une consultation médicale est conseillée avant la prestation.
            </p>
          </section>

          {/* Section 7 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">7. Paiement & facturation</h2>
            <div className="bg-gray-50 rounded-xl p-4 md:p-6 space-y-2">
              <p><strong>Tarif :</strong> Selon le service choisi (voir page Services & Tarifs)</p>
              <p><strong>Modalité :</strong> À domicile, avant ou après la prestation (à convenir)</p>
              <p><strong>Moyens acceptés :</strong> Espèces, virement, PayPal, cartes bancaires (selon disponibilité)</p>
            </div>
          </section>

          {/* Section 8 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">8. Protection des données personnelles (RGPD)</h2>
            <p className="mb-3">Les données collectées via le formulaire de contact (nom, téléphone, message) sont :</p>
            <ul className="list-disc list-inside space-y-1 mb-4 text-gray-600">
              <li>Utilisées UNIQUEMENT pour confirmer votre rendez-vous</li>
              <li>Jamais partagées avec des tiers</li>
              <li>Stockées de façon sécurisée</li>
              <li>Supprimées sur demande</li>
            </ul>
            <p className="text-gray-600 text-sm">
              Vous disposez du droit d'accès, de rectification et de suppression de vos données. Contactez-nous via WhatsApp pour exercer ce droit.
            </p>
          </section>

          {/* Section 9 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">9. Propriété intellectuelle</h2>
            <p className="text-gray-600">
              Tout contenu du site (photos, textes, logos) est la propriété de Nailed by Chloé. La reproduction ou utilisation sans autorisation est interdite.
            </p>
          </section>

          {/* Section 10 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">10. Modifications des conditions</h2>
            <p className="text-gray-600">
              Nailed by Chloé se réserve le droit de modifier ces conditions à tout moment. Les modifications seront affichées sur cette page. La date de dernière mise à jour sera mise à jour en haut de la page.
            </p>
          </section>

          {/* Section 11 */}
          <section className="mb-8">
            <h2 className="text-xl font-bold text-gray-800 mb-4">11. Loi applicable & juridiction</h2>
            <p className="text-gray-600">
              Ces conditions sont régies par la loi française. Tout litige sera traité conformément à la législation française et la jurisprudence du ressort géographique de La Réunion.
            </p>
          </section>

          {/* Contact */}
          <section className="mt-12 p-6 bg-rose-50 rounded-2xl text-center">
            <p className="font-semibold text-gray-800 mb-3">Pour toute question :</p>
            <div className="space-y-2 text-gray-600">
              <p>
                <a 
                  href="https://wa.me/33640486009?text=Bonjour%2C%20j%27ai%20une%20question%20concernant%20les%20CGV" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-green-600 hover:underline font-medium"
                >
                  WhatsApp : +33 6 40 48 60 09
                </a>
              </p>
              <p>
                <a 
                  href="mailto:Nailedbychloe@gmail.com" 
                  className="text-rose-600 hover:underline font-medium"
                >
                  Email : Nailedbychloe@gmail.com
                </a>
              </p>
              <p className="text-sm">ou via le formulaire de contact du site</p>
            </div>
          </section>

        </article>
      </main>

      {/* Footer simple */}
      <footer className="border-t border-gray-100 py-6 mt-12">
        <div className="container mx-auto px-4 text-center">
          <Link to="/" className="text-rose-600 hover:underline font-medium">
            ← Retour à l'accueil
          </Link>
        </div>
      </footer>
    </div>
  );
};
